<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
  >
    <section class="mx-auto flex w-full max-w-md flex-col content-center items-center justify-start">
      <div class="flex flex-col items-center">
        <WidgetIcon :icon="settings.icon"></WidgetIcon>
        <div class="flex w-full flex-col items-center py-5">
          <div class="flex flex-col items-center gap-8">
            <h2 class="title3-bold text-center font-medium">{{ settings.title }}</h2>
            <template v-for="(paragraph, index) in settings.paragraphs">
              <template v-if="typeof paragraph === 'string'">
                <p :key="index" class="body2 text-fontSecondary-500">
                  {{ replaceSpecificData(paragraph) }}
                </p>
              </template>
              <template v-else>
                <div :key="index" class="flex flex-row items-center gap-2">
                  <WidgetIcon v-if="paragraph.icon" :icon="paragraph.icon"></WidgetIcon>
                  <p class="body2 text-fontSecondary-500">{{ replaceSpecificData(paragraph.text) }}</p>
                </div>
              </template>
            </template>
            <a
              v-if="!!config.contact?.link"
              type="ghost"
              class="group !-ml-4 mb-4 hover:border-transparent hover:bg-white"
              :href="config.contact.link"
              target="_blank"
            >
              <h2 class="body2 font-medium group-hover:underline">{{ config.contact.link }}</h2>
            </a>
          </div>

          <div class="mt-8 flex w-full justify-center">
            <WButton class="bg-primary text-white" @click="doAction">
              {{ settings.action }}
            </WButton>
          </div>
        </div>
      </div>
    </section>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WidgetIcon from '../../base/WidgetIcon.vue';
  import { config } from 'src/utils/config';
  import WButton from '../../base/Button.vue';

  type Pragraph = {
    text: string;
    icon?: string;
  };
  export type UnsupportedStepConfig = {
    title: string;
    paragraphs: (string | Pragraph)[];
    action: string;
    icon: string;
    ctaAction: {
      call?: string;
      url?: string;
    };
  };

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsControl(props));
  const settings = (control.control.value.schema as unknown as { unsupportedStep: UnsupportedStepConfig })
    .unsupportedStep;

  function doAction() {
    if (settings?.ctaAction?.url) {
      return window.open(settings.ctaAction.url);
    }
    if (settings?.ctaAction?.call) {
      return window.open(`tel:${settings.ctaAction.call}`);
    }
    return window.open(`tel:${config.value.contact.phone}`);
  }

  function replaceSpecificData(paragraph: string) {
    const replacements = {
      '#phone': settings?.ctaAction?.call || config.value.contact.phone,
      '#client': config.value.name,
    };
    let response = paragraph;
    Object.entries(replacements).forEach(([key, value]) => {
      response = response.replaceAll(key, value);
    });
    return response;
  }
</script>
